import dayjs from "dayjs";
import { Pagination } from "../../Atoms/Pagination";
import * as S from "./styles";
import { useInvoicesSchedule } from "./useInvoicesSchedule";
import { TipoPagamento } from "../../../enums/tipoPagamento";
import { maskMoney } from "../../../utils/masks";
import { StatusPagamentoEnum } from "../../../enums/statusPagamento";

export const InvoicesSchedule = () => {
  const { isMobile, pagination, setNumberPage, faturas, acessarFatura } =
    useInvoicesSchedule();

  return (
    <S.Container>
      {faturas?.length > 0 ? (
        <S.Table>
          {faturas.map((f) => (
            <S.ItemTable key={Math.random()}>
              <p>
                DATA DE REALIZAÇÃO:{" "}
                <span>{dayjs(f.dataAutorizacao).format("DD/MM/YYYY")}</span>
              </p>
              <p>
                FORMA DE PAGAMENTO:{" "}
                <span>
                  {f?.boleto ? TipoPagamento.BOLETO : TipoPagamento.PIX}
                </span>
              </p>
              <p>
                VALOR: <span>{maskMoney(f?.valorTotal / 100)}</span>
              </p>
              <p>
                STATUS: <span>{f?.status}</span>
              </p>

              <div>
                {f?.status === StatusPagamentoEnum.pending ? (
                  <button type="button" onClick={() => acessarFatura(f)}>
                    Ver Fatura
                  </button>
                ) : (
                  <div></div>
                )}
              </div>
            </S.ItemTable>
          ))}
        </S.Table>
      ) : (
        <p>Nenhuma fatura encontrada</p>
      )}

      {faturas?.length > 0 && (
        <S.WrapperPagination>
          <Pagination
            maxPageNumbersDisplayed={isMobile ? 3 : 10}
            key={`${Math.random()} - ${pagination}`}
            totalPage={pagination?.totalPage}
            totalRegister={pagination?.totalPage}
            actualPage={pagination?.actualPage}
            setNumberPage={setNumberPage}
          />
        </S.WrapperPagination>
      )}
    </S.Container>
  );
};
